import { Table } from "capitalrx-components-2.0/lib/general";
import styled from "styled-components";

export const UniformRowColorTable = styled(Table)`
  tbody {
    tr {
      td {
        background-color: white !important;
      }
    }
  }

  thead {
    tr {
      th {
        background-color: white !important;
      }
    }
  }
`;
